// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2zBJa","title":"Info_title__1fYnl","selects":"Info_selects__uhzHq","requiredAsterisk":"Info_requiredAsterisk__30Re0"};